import {Dispatch} from "redux";
import {
    addMixToLocalStorage,
    getMixFromLocalStorage,
    removeMixToLocalStorage
} from "../services/utils/localStorageHelper";
import {MixesAPI} from "../services/api/Api";
import {IMix} from "../constants/types";
import {AppStateType} from "../services/rootReducer";

export const ADD_FAVORITE = 'Favorite/ADD_FAVORITE';
export const REMOVE_FAVORITE = 'Favorite/REMOVE_FAVORITE';
export const INITIALIZATION_DATA = 'Favorite/INITIALIZATION_DATA';
export const SET_CURRENT_MIX = 'Favorite/SET_CURRENT_MIX';
export const IS_INIT_WAS = 'Favorite/IS_INIT_WAS';
export const UPDATE_FAVORITE_MIX = 'Favorite/UPDATE_FAVORITE_MIX';
export const UPDATE_ALL_FAVORITE_MIX_START = 'Favorite/UPDATE_ALL_FAVORITE_MIX_START';
export const UPDATE_ALL_FAVORITE_MIX_SUCCESS = 'Favorite/UPDATE_ALL_FAVORITE_MIX_SUCCESS';

interface IFavoriteState {
    favoriteMixes: Array<IMix>,
    isInitWas: boolean,
    currentMix: IMix | null,
    isLoading: boolean;
}

interface IFavoriteAction {
    type: string,
    payload: any
}

const initialState: IFavoriteState = {
    favoriteMixes: [],
    isInitWas: false,
    currentMix: null,
    isLoading: false
};

const changeFavoriteMix = (countLikes: number, isLiked: boolean, indexMix: number) => ({
    type: UPDATE_FAVORITE_MIX,
    payload: [countLikes, isLiked, indexMix]
});

const setFavoriteMix = (favoriteMix: Array<object>) => ({
    type: UPDATE_ALL_FAVORITE_MIX_SUCCESS,
    payload: favoriteMix
});

export const updateFavoriteMix = (id: number, isMixLiked: boolean) => {
    return async (dispatch: Dispatch, getState: () => AppStateType) => {
        const favoriteMixes = getState().favorite.favoriteMixes;
        const mixIndex = favoriteMixes.findIndex((item: any) => item.id === id);
        if (isMixLiked) {
            const res = await MixesAPI.unlikeMix(id);
            dispatch(changeFavoriteMix(res.likeCount, false, mixIndex));
        } else {
            const res = await MixesAPI.likeMix(id);
            dispatch(changeFavoriteMix(res.likeCount, true, mixIndex));
        }
    }
};

export const initializationData = () => {
    return async (dispatch: Dispatch, getState: () => AppStateType) => {
        const isInitWas = getState().favorite.isInitWas;
        if (!isInitWas) {
            const allMixes = getMixFromLocalStorage();
            dispatch({
                type: INITIALIZATION_DATA,
                payload: allMixes
            });
            dispatch({type: IS_INIT_WAS});
        }
    }
};

export const addFavoriteMix = (mix: IMix) => {
    addMixToLocalStorage(mix);
    return async (dispatch: Dispatch) => {
        dispatch({
            type: ADD_FAVORITE,
            payload: mix
        })
    }
};

export const removeFavoriteMix = (id: number) => {
    removeMixToLocalStorage(id);
    return async (dispatch: Dispatch) => {
        dispatch({
            type: REMOVE_FAVORITE,
            payload: id
        })
    }
};

export const handlerFavoriteMix = (mix: IMix) => async (dispatch: Dispatch, getState: () => AppStateType) => {
    const favorite = getState().favorite.favoriteMixes;
    const findMix = favorite.find((item: any) => item.id === mix.id);
    if (findMix) {
        dispatch<any>(removeFavoriteMix(mix.id))
    } else {
        dispatch<any>(addFavoriteMix(mix));
    }
};

export const setCurrentMix = (id: number) => {
    return async (dispatch: Dispatch, getState: () => AppStateType) => {
        const favoriteMixes = getState().favorite.favoriteMixes;
        dispatch({
            type: SET_CURRENT_MIX,
            payload: favoriteMixes[id]
        });
    }
};

export const updateAllFavoriteMix = () => {
    return async (dispatch: Dispatch, getState: () => AppStateType) => {
        const favoriteMixes = getState().favorite.favoriteMixes;
        if (favoriteMixes.length) {
            dispatch({type: UPDATE_ALL_FAVORITE_MIX_START});
            const mixesId = favoriteMixes.map((item: any) => item.id);
            MixesAPI.getMixesByIds(mixesId)
                .then(res => dispatch(setFavoriteMix(res)))
                .catch(e => console.error(e))
        }
    }
};

const FavoriteReducer = (state = initialState, action: IFavoriteAction): IFavoriteState => {

    switch (action.type) {
        case INITIALIZATION_DATA:
            return {
                ...state,
                favoriteMixes: action.payload
            };

        case ADD_FAVORITE:
            return {
                ...state,
                favoriteMixes: [...state.favoriteMixes, action.payload]
            };

        case REMOVE_FAVORITE:
            return {
                ...state,
                favoriteMixes: state.favoriteMixes.filter((item: any) => item.id !== action.payload)
            };

        case IS_INIT_WAS:
            return {
                ...state,
                isInitWas: true
            };

        case SET_CURRENT_MIX:
            return {
                ...state,
                currentMix: action.payload
            };

        case UPDATE_FAVORITE_MIX:
            const newState: any = [...state.favoriteMixes];
            const [likeCount, isLiked, indexMix] = action.payload;
            newState[indexMix].isLiked = isLiked;
            newState[indexMix].likeCount = likeCount;
            return {
                ...state,
                favoriteMixes: newState
            };

        case UPDATE_ALL_FAVORITE_MIX_START:
            return {
                ...state,
                isLoading: true
            };

        case UPDATE_ALL_FAVORITE_MIX_SUCCESS:
            return {
                ...state,
                favoriteMixes: action.payload,
                isLoading: false
            };

        default:
            return state;
    }
};

export default FavoriteReducer;
